/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useState } from "react";
import {
    Col,
    Label,
    Row
} from "reactstrap";
import { CameraModal } from "./CameraModal";
import { FilesModal } from "./FilesModal";
import { ManualImage } from "./ManualImage";

type ModalState =
    | { type: "none" }
    | { type: "camera"; requiredImage: any }
    | { type: "files"; requiredImage: any };

export interface ManualImagesProps {
    images: any[];
    required_images: any[];
    saveImage: (arg0: any, arg1: any, arg2: any) => Promise<any>;
    deleteImage: (arg0: any) => void;
    isLoading: boolean;
}

export function ManualImages({ required_images, saveImage, images, deleteImage, isLoading }: ManualImagesProps) {
    const [modalState, setModalState] = useState<ModalState>({ type: "none" });

    const _saveImage = (imageType: string, base64: string, focusMode: any) => saveImage(imageType, base64, focusMode);

    const imageWrapperStyle = css`cursor:pointer; width: 30%; min-width: 6rem; max-width: 10rem;`;

    return (
        <div>
            <div>{required_images.map((req_image, index) => {
                const hasImage = images.filter((x) => req_image.type === x.type).length > 0;
                const isEmpty = req_image.mandatory && !hasImage;

                return <Row className={`${index > 0 ? "mb-3" : "mb-3"}`} key={req_image.type} >
                    <Col>
                        <Label>
                            {String(req_image.label)}
                            {req_image.mandatory && <span className={isEmpty ? "text-danger ms-1" : "ms-1"}>*</span>}
                        </Label>
                        <div className="d-flex flex-wrap">
                            {images.filter((x) => req_image.type === x.type).map((x, index) => <div
                                key={index}
                                css={imageWrapperStyle}
                                onClick={() => setModalState({ type: "files", requiredImage: req_image })}
                                className="pt-2 me-3">
                                <ManualImage image={x} />
                            </div>)}
                            <div css={imageWrapperStyle} className="pt-2 me-3" onClick={() => setModalState({ type: "camera", requiredImage: req_image })} >
                                <ManualImage image={({})} />
                            </div>
                        </div>
                    </Col>
                </Row>;
            })}

            {modalState.type === "camera" && (
                <CameraModal
                    requiredImage={modalState.requiredImage}
                    onClose={() => setModalState({ type: "none" })}
                    onSaveImage={_saveImage}
                    onOpenFiles={() => setModalState({ type: "files", requiredImage: modalState.requiredImage })}
                />
            )}

            {modalState.type === "files" && (
                <FilesModal
                    requiredImage={modalState.requiredImage}
                    images={images}
                    onClose={() => setModalState({ type: "none" })}
                    onSaveImage={_saveImage}
                    onDeleteImage={deleteImage}
                    onOpenCamera={() => setModalState({ type: "camera", requiredImage: modalState.requiredImage })}
                    isLoading={isLoading}
                />
            )}
            </div>
        </div>
    );
}

